export default function initializeSelects() {
    document.querySelectorAll('.wpfMainWrapper').forEach(function (pd) {
        new init(pd);
    });
}

function init(pd) {

    const closeAllSelects = () => {
        document.querySelectorAll('.wpfFilterWrapper').forEach(function (pd) {
            if (!pd.querySelector('.wpfFilterContent ').classList.contains('wpfHide')) {
                pd.querySelector('.wpfFilterContent ').classList.add('wpfBlockAnimated');
                // opoznienie zamkniecia
                setTimeout(() => {
                    pd.querySelector('.wpfFilterContent ').classList.add('wpfHide');
                }, 50);
            }
            if (pd.querySelector('.wpfTitleToggle').classList.contains('fa-chevron-up')) {
                pd.querySelector('.wpfTitleToggle').classList.remove('fa-chevron-up');
                pd.querySelector('.wpfTitleToggle').classList.add('fa-chevron-down');
            }
        });
    };

    document.addEventListener('click', (event) => {
        if (!event.target.closest('.wpfFilterWrapper')) {
            closeAllSelects()
        }
    });
}